import { useDispatch, useSelector } from 'react-redux'
import { ManagedModal, hideModal } from '~/state/modalManager/modalManagerSlice'
import { getVisibleModal } from '~/state/modalManager/selectors'
import { getIsNewSignup } from '~/state/currentUser/selectors'
import { SubscribeModal } from '../UserAnnouncement/Announcements/SignupModal'
import { AcceptTOSModal } from '../Common/AcceptTOSModal'

export const ModalPlacement = () => {
    const visibleModal = useSelector(getVisibleModal)
    const isNewSignup = useSelector(getIsNewSignup)
    const dispatch = useDispatch()

    const handleClose = () => {
        dispatch(hideModal())
    }

    // show subscription modal to new signups
    const showSubscriptionModal =
        visibleModal === ManagedModal.Subscription || isNewSignup

    if (visibleModal === ManagedModal.TermsOfService) {
        return <AcceptTOSModal />
    }

    if (showSubscriptionModal) {
        return <SubscribeModal onClose={handleClose} />
    }

    return null
}
